var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAs = function SvgIconAs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.822 1.505A11.95 11.95 0 0 0 12 0C5.373 0 0 5.372 0 11.999l8.348-4.173zM0 12.002C0 18.629 5.373 24 12 24c2.113 0 4.097-.546 5.822-1.505l-9.474-6.32z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M18.822 2.127q-.485-.334-1-.622L0 11.998v.003l17.821 10.493q.517-.287 1-.622L2.055 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M20.87 11.553h-1.43a1.135 1.135 0 0 0-.07-1.53 1.136 1.136 0 0 0 0-1.605l-.027.026c.444-.443.47-1.189.027-1.632l-6.425 6.424a1.12 1.12 0 0 0 1.594-.005l.123-.113 3.077-.28v1.323h1.043v-1.418l1.566-.142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M13.044 14.609 12 14.087l1.044-.522h6.782v1.044z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAs;